module.exports = __webpack_public_path__ + "img/dente-inf.86c66516.svg";